<template>
  <timeline-step
    :ref="`step-${step.id}`"
    :step="step"
    :dusk="`timeline-step-${step.id}`"
    @toggleStep="toggleStep(step.id)"
  >
    <div class="flex justify-center">
      <a href="/campaigns" class="button button-primary mt-4">Campaigns</a>
    </div>
  </timeline-step>
</template>

<script>
export default {
  props: ['step'],
};
</script>
